export default __webpack_public_path__ + "static/media/WMATIC_DFYN.46419c95.svg";